"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMediaCampaignGroupDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchMediaCampaignGroupDto extends cursor_pagination_1.CursorPaginationOptions {
    title;
    ownerId;
    notOwnerId;
    displayId;
    displayOwnerId;
    notDisplayOwnerId;
    displayProviderId;
    mediaId;
    reqId;
    playlistId;
    from;
    to;
    date;
    mediaType;
    mediaCampaignId;
    showWithPrice;
    showAccepted;
    isExpired;
    isPaid;
    status;
    notStatus;
    createdAtFrom;
    createdAtTo;
    /**
     * @deprecated Use `cursor` and `limit` for pagination instead. This field will be removed in future versions.
     */
    offset;
}
exports.SearchMediaCampaignGroupDto = SearchMediaCampaignGroupDto;
